import {
  defineComponent,
} from 'vue';

export default defineComponent({
  delimiters: ['${', '}'],
  props: {
    sku: {
      type: String,
      default: null,
    },
    salePrice: {
      type: String,
      default: null,
    },
    quantity: {
      type: Number,
      default: null,
    },
    bulkPriceQuantity: {
      type: Number,
      default: null,
    },
    salePriceQuantity: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    isCustomer() {
      return this.$store.getters.statuses.isCustomer;
    },
    isCustomerWithSaleAccess() {
      return this.$store.getters.statuses.isCustomerWithSaleAccess;
    },
    showSalePrice() {
      return this.salePrice && this.isCustomerWithSaleAccess && (this.salePriceQuantity !== null && this.quantity >= this.salePriceQuantity);
    },
    showBulkPrice() {
      return !this.showSalePrice && this.quantity >= this.bulkPriceQuantity && this.bulkPriceQuantity > 0;
    },
    isStopped() {
      return this.$store.getters.statuses.isStopped;
    },
    priceUnavailable() {
      return this.price && this.price == '£0.00';
    },
    price() {
      return this.$store.getters.variantPrice(this.sku);
    },
    isVariantPriceValid() {
      return this.$store.getters.isVariantPriceValid(this.sku);
    },
    bulkPrice() {
      if (this.quantity < this.bulkPriceQuantity) {
        return null;
      }
      return this.$store.getters.variantBulkPrice(this.sku);
    },
    productImportDateTime() {
      return this.$store.state.productImportDateTime;
    },
  },
  watch: {
    isCustomer() {
      if (this.hasPricingAccess() && !this.price) {
        this.getPrice();
      }
    },
    isStopped() {
      if (this.hasPricingAccess() && !this.price) {
        this.getPrice();
      }
    },
    productImportDateTime() {
      if (this.hasPricingAccess() && !this.isVariantPriceValid) {
        this.getPrice();
      }
    },
  },
  created() {
    this.$store.dispatch('getProductImportDateTime', {});
  },
  mounted() {
    if ((this.hasPricingAccess() && !this.price)) {
      this.getPrice();
    }
  },
  methods: {
    hasPricingAccess() {
      return this.isCustomer && !this.isStopped;
    },
    async getPrice() {
      if (!this.hasPricingAccess()) {
        return;
      }
      // Set Product SKU to fetch
      const productSkus = [this.sku];
      // Prep the payload
      const payload = {
        productSkus,
      };
      // Prevent strange issue where object property values can be cached in their reactive state
      Object.freeze(payload);
      this.isLoading = true;
      // Send payload
      await this.$store.dispatch('getPrices', payload);
      this.isLoading = false;
    },
    async getBulkPrice() {
      if (!this.hasPricingAccess()) {
        return;
      }
      // Prep the payload
      const payload = {
        sku: this.sku,
        quantity: this.bulkPriceQuantity,
      };
      this.isLoading = true;
      // Send payload
      await this.$store.dispatch('getBulkPrice', payload);
      this.isLoading = false;
    },
  },
  template: '#t-product-price',
});
